<template>
    <label
        v-if="label && label !== ''"
        :class="classBuilder"
    >
        <template v-if="!isLoading">
            {{ label }}
            <span
                v-if="optional"
                class="FieldLabel__optional"
            >(optional)</span>
            <RPTooltip
                v-if="labelTooltip !== ''"
                class="FieldLabel__icon"
                :tooltip="labelTooltip"
            />
        </template>
    </label>
</template>
<script>
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';
import RPTooltip from 'components/Basic/Misc/RPTooltip.vue';

export default {
    name: 'FieldLabel',
    components: {
        RPTooltip
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        labelTooltip: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        optional: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        classBuilder(){
            return statusBuilder(
                'FieldLabel',
                this.status,
                this.disabled
            );
        },
    }
};
</script>
<style lang="scss">
    .FieldLabel {
        display: flex;
        align-items: center;
        font-size: .8rem;
        color: $grey;
        font-weight: 600;
        margin-bottom: .25rem;

        @include loading(.8rem, 7.5rem);

        &--disabled {
            color: $grey-200;
        }
        &__icon {
            margin: auto 0 auto .5rem;
        }
        &__optional{
            font-weight: 400;
            font-size: 0.7rem;
            margin-left: 0.25rem;
        }
    }
</style>
